import { render, staticRenderFns } from "./reply-pagination.vue?vue&type=template&id=680bc598"
import script from "./reply-pagination.vue?vue&type=script&lang=js"
export * from "./reply-pagination.vue?vue&type=script&lang=js"
import style0 from "./reply-pagination.vue?vue&type=style&index=0&id=680bc598&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports